/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { SdsDivProps } from '../Component.props';
import { GridItem } from './Grid.defs';

/**
 * The props for `<Grid />`.
 */
export interface GridProps extends SdsDivProps {
  /**
   * The number of grid columns.
   */
  columnCount?: number;

  /**
   * The item list to be passed to the grid.
   */
  items: Array<GridItem>;

  /**
   * The column gap size.
   */
  gap?: number;
}

/**
 * The default prop values for `<Grid />`.
 */
export const gridDefaults = {
  columnCount: 12,
  items: [],
};
